import { createContext } from "react";
import { AgendaItemsApi } from "services/AgendaItemsApi";
import { BoardApi } from "services/BoardApi";
import { BoardMembersApi } from "services/BoardMembersApi";
import { BoardsApi } from "services/BoardsApi";
import { BoardSendToApi } from "services/BoardSendToApi";
import { DashboardApi } from "services/DashboardApi";
import { DownloadApi } from "services/DownloadApi";
import { EdecideApi } from "services/EdecideApi";
import { MeetingApi } from "services/MeetingApi";
import { MeetingsApi } from "services/MeetingsApi";
import { OneDriveApi } from "services/OneDriveApi";
import { OutputDocumentsApi } from "services/OutputDocumentsApi";
import { ParticipantsApi } from "services/ParticipantsApi";
import { PermissionsApi } from "services/PermissionsApi";
import { SendToApi } from "services/SendToApi";
import { StandardMeetingApi as StandardMeetingsApi } from "services/StandardMeetingsApi";
import { SuggestedAgendaItemsApi } from "services/SuggestedAgendaItemsApi";
import { TasksApi } from "services/TasksApi";
import { TemplatesApi } from "services/TemplatesApi";
import { UserApi } from "services/UserApi";
import { WorkingDocumentsApi } from "services/WorkingDocumentsApi";

export interface ApiContextProps {
  boardsApi: BoardsApi;
  boardApi: BoardApi;
  boardSendToApi: BoardSendToApi;
  downloadApi: DownloadApi;
  userApi: UserApi;
  dashboardApi: DashboardApi;
  meetingsApi: MeetingsApi;
  meetingApi: MeetingApi;
  agendaItemsApi: AgendaItemsApi;
  standardMeetingsApi: StandardMeetingsApi;
  suggestedAgendaItemsApi: SuggestedAgendaItemsApi;
  sendToApi: SendToApi;
  participantsApi: ParticipantsApi;
  tasksApi: TasksApi;
  oneDriveApi: OneDriveApi;
  edecideApi: EdecideApi;
  workingDocumentsApi: WorkingDocumentsApi;
  boardMembersApi: BoardMembersApi;
  outputDocumentsApi: OutputDocumentsApi;
  permissionsApi: PermissionsApi;
  templatesApi: TemplatesApi;
}

export const ApiContext = createContext({} as ApiContextProps);
